import Lottie from "lottie-react";
import React , {useEffect} from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import * as sendingAnimation from "../../../assets/images/lottie/sending.json";
import { formatFileSize, getFileIcon } from "../../../libs/utils";
import FileUploadCard from "./FileUploadCard";
import { useAuth } from "../../../_helper/Auth/AuthProvider";

const FileUploadModal = ({
  isOpen,
  uploadProgress,
  selectedFiles,
  uploadStatus,
  setUploadStatus,
  //theme,
  setIsUploadModalOpen,
  ticketId,
  files,
  uploadErrors,
  fileUploadMeta,
  handleRemoveFile,
  handleDeleteFile,
  isOverwriteShown,
  loadingOverwrite,
  setSelectedFiles,
  handleUploadFile,
  isUploading,
}) => {
   const { theme } = useAuth();
  // Calculate overall progress and prevent negatives
  const overallProgress =
    selectedFiles.length > 0
      ? Math.max(
          selectedFiles.reduce((acc, file) => {
            const progress = uploadProgress[file.name] ?? 0;
            return acc + progress;
          }, 0) / selectedFiles.length,
          0
        )
      : 0;

      useEffect(() => {
        if (selectedFiles?.length === 0) {
          setIsUploadModalOpen(false);
        }
      }, [selectedFiles]);

  return (
    <Modal
      isOpen={isOpen}
      centered
      size="lg"
      backdrop="static"
      keyboard={false}
      className="file-upload-modal"
      style={{ maxWidth: "700px" }} // Increased modal width
    >
      <ModalHeader className="border-0 text-center">
        <h4 className="mb-0" style={{ fontWeight: "600", color: theme === "dark-only" ? '#ffffff99' :'2f2f3b'}}>
          {isUploading
            ? "Uploading Files..."
            : uploadStatus === "Some files failed to upload."
            ? "Some files failed to upload."
            : "Ready to Upload Files"}
        </h4>
      </ModalHeader>
      <ModalBody className="p-4">
        {isUploading && (
          <>
            {/* Lottie Animation */}
            <div className="mb-3">
              <Lottie
                animationData={sendingAnimation}
                loop={true}
                style={{ height: 150, width: 150, margin: "0 auto" }}
              />
            </div>

            {/* Progress Bar */}
            <div
              className="progress mb-3"
              style={{
                height: "12px",
                borderRadius: "10px",
                overflow: "hidden",
                background: "#e9ecef",
              }}
            >
              <div
                className="progress-bar progress-bar-striped progress-bar-animated"
                role="progressbar"
                style={{
                  width: `${Math.max(overallProgress, 0)}%`,
                  backgroundColor: "#007bff",
                  borderRadius: "10px",
                }}
                aria-valuenow={Math.max(overallProgress, 0)}
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>

            <p className="text-muted mb-3" style={{ fontSize: "0.95rem" }}>
              {Math.round(overallProgress)}% Complete
            </p>
            {/* Upload Status */}
            <p
              className="mt-3 text-muted"
              style={{
                fontSize: "0.9rem",
                wordWrap: "break-word", // Ensures long words wrap
                overflowWrap: "break-word", // Alternative for better compatibility
                whiteSpace: "normal", // Prevents text from staying in one line
              }}
            >
              {uploadStatus}
            </p>
          </>
        )}

        <div style={{ marginTop: "15px" }}>
          {selectedFiles.map((file, index) => {
            const progress = uploadProgress[file.name] ?? 0;
            const errorMsg = uploadErrors[file.name];
            const meta = fileUploadMeta[file.name] || {};
            const remainingTime = meta.timeRemainingSec;

            const formatTime = (seconds) => {
              if (seconds == null) return null;
              if (seconds <= 0) return "Done";
              if (seconds < 60) return `${seconds}s`;
              const mins = Math.floor(seconds / 60);
              const secs = seconds % 60;
              return `${mins}m ${secs}s`;
            };

            return (
              <FileUploadCard
                key={file.key}
                file={file}
                files={files}
                ticketId={ticketId}
                index={index}
                theme={theme}
                progress={progress}
                remainingTime={remainingTime}
                errorMsg={errorMsg}
                handleRemoveFile={handleRemoveFile}
                handleDeleteFile={handleDeleteFile}
                isOverwriteShown={isOverwriteShown}
                loadingOverwrite={loadingOverwrite}
                formatFileSize={formatFileSize}
                formatTime={formatTime}
                getFileIcon={getFileIcon}
                uploadStatus={uploadStatus}
                setUploadStatus={setUploadStatus}
              />
            );
          })}

          {uploadStatus === "Some files had issues." ? (
            <div
              style={{
                display: "flex",
                gap: "10px",
                marginTop: 50,
                justifyContent: "flex-end",
              }}
            >
              <Btn
                attrBtn={{
                  onClick: () => [
                    setSelectedFiles([]),
                    setIsUploadModalOpen(false),
                    setUploadStatus(""),
                  ],
                  color: "primary",
                }}
              >
                Okay
              </Btn>
            </div>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  marginTop: 50,
                  justifyContent: "flex-end",
                }}
              >
                <Btn
                  attrBtn={{
                    onClick: handleUploadFile,
                    color: "primary",
                    disabled: isUploading,
                  }}
                >
                  <i
                    className="fa fa-upload"
                    style={{ fontSize: 14, paddingRight: 8 }}
                  ></i>
                  Upload
                </Btn>
                <Btn
                  attrBtn={{
                    onClick: () => [
                      setSelectedFiles([]),
                      setIsUploadModalOpen(false),
                    ],
                    color: "danger",
                    disabled: isUploading,
                  }}
                >
                  Cancel
                </Btn>
              </div>
            </>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default FileUploadModal;
